import cx from 'classnames'
import type React from 'react'

import css from './IconButton.module.scss'

type Props = {
  icon: React.ReactNode
  classNames?: string
  hidden?: boolean
  disabled?: boolean
  active?: boolean
  eventHandlers?: {
    onSetRef?: (
      value:
        | ((prevState: HTMLElement | null) => HTMLElement | null)
        | HTMLElement
        | null
    ) => void
    onMouseEnter?: () => void
    onMouseLeave?: () => void
  }
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
}

export const IconButton: React.FC<Props> = ({
  classNames,
  hidden,
  icon,
  active,
  eventHandlers,
  onClick,
  disabled,
}) => {
  return (
    <button
      disabled={disabled}
      ref={eventHandlers?.onSetRef}
      className={cx(css.button, classNames, {
        [css.hidden]: hidden,
        [css.active]: active,
      })}
      onMouseEnter={eventHandlers?.onMouseEnter}
      onMouseLeave={eventHandlers?.onMouseLeave}
      onClick={(e) => {
        e.stopPropagation()
        onClick(e)
      }}
    >
      {icon}
    </button>
  )
}
